/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { Box, ChipProps, Stack, TextFieldProps } from '@mui/material';
import { Control } from 'react-hook-form';

import AutocompleteElement from './AutoComplete';
import { FormInputProps } from './interface/FormInputProps';

interface IProps extends FormInputProps {
  isMultiselect?: boolean;
  chipStyle?: any;
  name: string;
  control: Control<any>;
  renderCustomComponent?: (value: string, props?: ChipProps) => React.ReactNode;
  loading?: boolean;
  showCheckbox?: boolean;
  defaultValue?: string | number | null;
  required?: boolean;
  labelKey?: string;
  valueKey?: string;
  countKey?: string;
  textFieldProps?: Omit<TextFieldProps, 'name' | 'required' | 'label'>;
  fixedValues?: any;
  readOnly?: boolean;
  canCreateNew?: boolean;
  addNewValue?: (value: string) => void;
  CustomInput?: React.ElementType;
  autoCompleteStyle?: any;
  disableCloseOnSelect?: boolean;
  isFilterCustomComponent?: boolean;
  isShowDropDown?: boolean;
  renderOption?: () => any;
  disableOptionCondition?: (option: any) => boolean;
  renderAction?: (value: string | any) => React.ReactElement;
  renderProgress?: (value: number) => React.ReactElement;
}

export default function RISelectComponent({
  isMultiselect = false,
  label,
  options,
  name,
  loading = false,
  showCheckbox = true,
  control,
  renderCustomComponent,
  required = false,
  fixedValues,
  readOnly,
  canCreateNew,
  CustomInput,
  addNewValue,
  disableCloseOnSelect,
  isShowDropDown,
  renderOption,
  disableOptionCondition,
  isFilterCustomComponent = false,
  ...props
}: IProps) {
  return (
    <AutocompleteElement
      readOnly={readOnly}
      label={label}
      name={name}
      multiple={isMultiselect}
      options={options || []}
      matchId
      showCheckbox={showCheckbox}
      control={control}
      loading={loading}
      required={required}
      fixedValues={fixedValues}
      canCreateNew={canCreateNew}
      addNewValue={addNewValue}
      CustomInput={CustomInput}
      disableCloseOnSelect={disableCloseOnSelect}
      isShowDropDown={isShowDropDown}
      autocompleteProps={{
        renderOption,
        getOptionDisabled: disableOptionCondition,
        renderTags: (value: any, getTagProps: any) =>
          renderCustomComponent ? (
            isFilterCustomComponent ? (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  gap: 0.5,
                  height: '55px',
                  alignItems: 'center',
                  overflow: 'scroll',
                  '&::-webkit-scrollbar': {
                    display: 'none',
                  },
                }}
              >
                {value.map((option: any, index: number) => (
                  <React.Fragment key={index}>
                    {renderCustomComponent(option, {
                      ...getTagProps({ index }),
                    })}
                  </React.Fragment>
                ))}
              </Box>
            ) : (
              <Stack direction="row" flexWrap="wrap" gap={1} key={Math.random()}>
                {value.map((option: any, index: number) => (
                  <React.Fragment key={index}>
                    {renderCustomComponent(option, {
                      ...getTagProps({ index }),
                    })}
                  </React.Fragment>
                ))}
              </Stack>
            )
          ) : null,
      }}
      {...props}
    />
  );
}
